<script>
  import { navigate } from "svelte-routing";
  import { deletePollDocument, updateDocument } from "../../apis/APIS";
  /* Executable code section of the program */
  //Tools importation
  import {
    userRealTime,
    isUpdatingPollsModal,
    temporalPollData,
    isAlertOn,
    alertMessagge,
    isConfirmModalOn,
    confirmResponse,
    isReloadNecessary,
    confirmDeletePoll
  } from "../../apis/storage";
  import ConfirmModal from "../Modals/ConfirmModal.svelte";
  import DeletePollModal from "../Modals/DeletePollModal.svelte";

  //Auxiliary variables
  export let poll;
  let answerSelected = "";

  if (poll[0] === undefined) {
    
    location.reload();
  }

  //Function to display alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  //Function to send and save poll answer
  const handleInput = (e) => {
    answerSelected = e.target.value;
  };
  const sendAnswer = () => {
    let pollId = poll[0].id;
    if (answerSelected !== "") {
      poll[0].options.forEach((element) => {
        if (element.optionTittle === answerSelected) {
          element.votes.push($userRealTime.id);
        }
      });
      updateDocument("polls", poll[0], poll[0].id).then(() => {
        $userRealTime.answeredPolls.push(poll[0].id);
        updateDocument("users", $userRealTime, $userRealTime.id)
          .then(() => {
            $alertMessagge = "Response sent successfully.";
            $isReloadNecessary = true;
            displayAlert();
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while sending your response, please try again.";
            displayAlert();
          });
      });
    } else {
      $alertMessagge = "You must select an answer to participate in the poll.";
      displayAlert();
    }
  };
  //Function to display confirm modal
  const displayConfirmModal = () => {
    $isConfirmModalOn = true;
    $confirmDeletePoll = true
    $alertMessagge = "Are you sure you want to delete this poll question?";
  };

  //Function to delete poll question
  const deletePoll = () => {
    if ($confirmResponse) {
      deletePollDocument(poll[0].id, "Poll")
        .then(() => {
          $confirmDeletePoll = false
          $alertMessagge = "Poll has been deleted successfully.";
          $isReloadNecessary = true;
          displayAlert();
        })
        .catch(() => {
          $alertMessagge = "An error occurred while deleting the poll.";
          displayAlert();
        });
    }
  };

  const displayUpdateModal = () => {
    $isUpdatingPollsModal = true;
    $temporalPollData = poll[0];
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  {#if !$userRealTime.answeredPolls.includes(poll[0].id) || $userRealTime.userRole !== "attendee"}
    <div class="questionContainer">
      <div class="actionTextContainer">
        <p class="tittleQuestion">{poll[0].question || ""}</p>
        {#if $userRealTime.userRole !== "attendee"}
          <div class="buttonsContainer">
            <div class="controlButtons">
              <button
                class="actionBtn hoverActionBtn"
                on:click={displayUpdateModal}
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                  />
                </svg></button
              >
              <button
                class="actionBtn hoverActionBtn"
                on:click={displayConfirmModal}
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
                  />
                  <path
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
                  />
                </svg></button
              >
            </div>
          </div>
        {/if}
      </div>
      <div class="answerContainer">
        {#each poll[0].options as option, index}
          <div class="form-check">
            <input
              class="form-check-input inputRadio"
              type="radio"
              name="exampleRadios"
              id="exampleRadios1"
              value={option.optionTittle}
              on:change={handleInput}
            />
            <label class="form-check-label" for="exampleRadios1">
              {option.optionTittle}
            </label>
          </div>
        {/each}
      </div>
    </div>
    <div class="submitButton">
      {#if $userRealTime.userRole !== "attendee"}
        <a
          href="/pollanswers/{poll[0].id}/{poll[0].questionTittle}"
          target="_blank"
        >
          <button class="actionBtn hoverActionBtn changeBtn"
            >View responses</button
          >
        </a>
      {/if}
      <button class="actionBtn hoverActionBtn changeBtn" on:click={sendAnswer}
        >Send Answer</button
      >
    </div>
  {:else}
    <div class="answeredPoll">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        fill="currentColor"
        class="bi bi-ui-checks"
        viewBox="0 0 16 16"
      >
        <path
          d="M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
        />
      </svg>
      <p>You have already responded to this poll</p>
    </div>
  {/if}
</section>
{#if $confirmDeletePoll}
  <DeletePollModal callbackFunction={deletePoll} />
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal container styles */
  .principalContainer {
    width: 100%;
    height: auto;
  }
  /* Control section styles */
  .buttonsContainer {
    width: 20%;
    height: auto;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }
  .controlButtons {
    width: 50%;
    height: auto;
    display: flex;
  }
  /* Buttons styles */
  .actionBtn {
    width: 100px;
    height: auto;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 5px;
  }
  .changeBtn {
    margin: 0 20px;
    width: 200px;
  }

  .hoverActionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* Question body styles */
  .questionContainer {
    width: 100%;
    height: auto;
    padding: 10px 30px;
  }
  .actionTextContainer {
    display: flex;
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid gray;
  }
  .tittleQuestion {
    width: 80%;
    height: auto;
    font-size: 50px;
    font-weight: 600;
  }
  .answerContainer {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 15px 30px;
  }
  .inputRadio {
    font-size: 20px;
  }
  /* Final button styles*/
  .submitButton {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }
  .answeredPoll {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30dvh;
    padding: 20px;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .actionTextContainer {
      width: 100%;
      padding: 10px;
      flex-direction: column-reverse;
    }
    /* Control section styles */
    .buttonsContainer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding: 10px;
    }
    .controlButtons {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .actionTextContainer {
      width: 100%;
      padding: 10px;
      flex-direction: column-reverse;
    }
    .tittleQuestion {
      width: 80%;
      height: auto;
      font-size: 30px;
      font-weight: 600;
    }
    /* Control section styles */
    .buttonsContainer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding: 10px;
    }
    .controlButtons {
      width: 100%;
      display: flex;
    }
    /* Buttons styles */
    .actionBtn {
      width: 200px;
      margin: 0 5px;
    }
  }
  /* End of the section */
</style>
